
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"40","viewBox":"0 0 40 40","width":"40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20z","fill":"#76e5fd"}}),_c('g',{attrs:{"stroke-miterlimit":"10"}},[_c('path',{attrs:{"d":"M19.913 13.333c.752-5.247-3.597-8.245-3.597-8.245","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M20.702 13.092s4.455-2.832 9.803.346c5.347 3.177 2.332 13.333 2.332 13.333s-3.358 9.118-6.926 9.118c-1.876.34-4.388-.827-4.388-.827s-1.784-1.038-3.359-.068c-1.578.967-3.907 2.004-5.963 0-1.91-1.868-7.439-8.148-5.174-17.074.588-2.314 2.155-4.293 4.339-5.228 1.203-.513 2.714-.799 4.548-.506.53.085 1.047.25 1.54.467.781.35 2.264.884 3.248.439z","fill":"#f44747","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M21.717 25.158s-.352 1.445-1.897 1.445-1.897-1.445-1.897-1.445","stroke":"#010101","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M23.553 22.43s.25-1.026 1.348-1.026 1.349 1.025 1.349 1.025M13.684 22.43s.25-1.026 1.349-1.026 1.348 1.025 1.348 1.025","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M20 11.438s-.059-6.02 5.57-7.93c0 0 1.754 6.258-4.667 8.922l-.903.377z","fill":"#16d2aa","stroke":"#000"}})])])
          )
        }
      }
    